// @flow
import * as React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { ModalCloseButton } from '@coverright/ui/shared';
import { AgentForm } from '../../../features';
import { AgentInput, AgentRoleInput } from '@coverright/data-access/types/enrollment';

type Props = {
  agent: Omit<AgentInput, 'role'> & {role: string},
  open: boolean,
  onClose: () => void
};
export const EditAgentModal = ({agent, open, onClose}: Props) => {
  return <Dialog fullWidth maxWidth={'sm'} open={open} onClose={onClose}>
    <DialogTitle variant={'h3'}>
      Agent info
      <ModalCloseButton onClick={onClose} sx={{position: 'absolute', top: 4, right: 8}} />
    </DialogTitle>
    <DialogContent>
      <AgentForm input={{...agent, role: agent.role as AgentRoleInput}} onSubmit={onClose} />
    </DialogContent>
  </Dialog>;
};
